// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import MobileSidebar from '../../components/MobileSidebar';
import inBrowser from '../../utils/inBrowser';
import { fetchJSON } from '../../utils/fetch';
import { receiveIndex } from '../../actions/version';
import { pinNav, receiveVersions, unpinNav } from '../../actions/app';
import type { API } from '../../reducers/version';

import style from './style.css';

type Props = {
  api: API;
  index: Object;
  version: string;
  children: Array<React$Element<*>>;
  location: Object;
  receiveIndex: typeof receiveIndex;
  receiveVersions: typeof receiveVersions;
  showPrivateAPI: boolean;
  pinNav: typeof pinNav;
  unpinNav: typeof unpinNav;
  navPinned: boolean;
};

@connect(({
  app: {
    navPinned,
    showPrivateAPI
  },
  version: {
    api,
    index,
    string
  }
}) => ({
  api,
  index,
  navPinned,
  showPrivateAPI,
  version: string
}), {
  pinNav,
  unpinNav,
  receiveIndex,
  receiveVersions
})
export default class AppContainer extends Component<void, Props, void> {
  contentView: HTMLElement;

  componentDidMount() {
    this.fetchIndex(this.props.version);
    this.fetchVersions();
  }

  componentDidUpdate({ version: prevVersion, children: prevChildren }: Object): void {
    const { props: { version, children } } = this;

    if (version !== prevVersion) {
      this.fetchIndex(version);
    }
    if (children !== prevChildren) {
      this.contentView.scrollTop = 0;
    }
  }

  async fetchIndex(): Promise<void> {
    if (inBrowser()) {
      const { props: { version } } = this;
      const index = await fetchJSON(`/static/data/${version}/index.json`);

      this.props.receiveIndex(index);
    }
  }

  async fetchVersions(): Promise<void> {
    if (inBrowser()) {
      const versions = await fetchJSON('/static/data/versions.json');

      this.props.receiveVersions(versions);
    }
  }

  render() {
    const {
      props: {
        api,
        index,
        location,
        navPinned,
        showPrivateAPI,
        version
      }
    } = this;

    return (
      <div className={style.appView}>
        <Header />
        <a
          className={style.skipView}
          href="#mainContent"
        >
          Skip to Main Content
        </a>
        <div className={style.mainView}>
          <Sidebar
            api={api}
            index={index}
            navPinned={navPinned}
            pathname={location.pathname}
            pinNav={this.props.pinNav}
            showPrivateAPI={showPrivateAPI}
            unpinNav={this.props.unpinNav}
            version={version}
          />
          <MobileSidebar
            index={index}
            pathname={location.pathname}
            version={version}
          />
          <main
            className={style.contentView}
            id="mainContent"
            ref={(c) => { this.contentView = c; }}
          >
            {this.props.children}
          </main>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/AppContainer/index.jsx